import React from 'react'
import { Typography, Box } from '@mui/material';
import { getRandomStr, roundNum } from '../../../../helpers';
import { dataConstants } from '../../../../constants';

const { ECO_SECTION_CODES } = dataConstants || {};

function CurrentInflationMeasures({ data }) {

  //cpi table
  const cpiTbl = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.GLA_CPI_TABLE) : undefined;
  const cpiTblData = cpiTbl && cpiTbl.tabData && cpiTbl.tabData.length > 0 ? cpiTbl.tabData : undefined;

  return (
    <>
      {cpiTbl &&
        <Box component="div" className="col-md-4" sx={{ height: '100%', }}>
          <Box component="div" className="section"
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 1.4,
              px: 0.5,
            }}>
            <Typography variant="body1" className="option-title" sx={{}} >
              {cpiTbl.section_name}
            </Typography>
          </Box>
          <Box component="div" className="option-content eco-chart" sx={{ position: 'relative', pr: 2 }}>
            <Box component="div" className="cpi-measures">
              {cpiTbl.settings.order.map(d => {
                const col = cpiTbl.settings.cols.find(c => c.code === d);
                const item = cpiTblData.find(it => it.code === d);
                return (col && item ?
                  <Box component="div" key={getRandomStr(3)}>
                    <Box className="cpi-m-item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.4, px: 3, my: 2 }} >
                      <Typography variant="body1" className="cpi-desc" sx={{ fontSize: '.87rem' }} >
                        {col.desc}
                      </Typography>
                      <Typography variant="body1" className="cpi-desc-num" sx={{ fontSize: '.87rem' }} >
                        {roundNum(item.value, 2)}%
                      </Typography>
                    </Box>
                  </Box>
                  : null);
              })}
            </Box>
          </Box>
        </Box>}
    </>
  )
}

export default React.memo(CurrentInflationMeasures)
